import { render, staticRenderFns } from "./BlackShadowModal.vue?vue&type=template&id=530b963a&scoped=true&"
import script from "./BlackShadowModal.vue?vue&type=script&lang=js&"
export * from "./BlackShadowModal.vue?vue&type=script&lang=js&"
import style0 from "./BlackShadowModal.vue?vue&type=style&index=0&id=530b963a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b963a",
  null
  
)

export default component.exports